import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    signers: [],
};

const signerSlice = createSlice({
    name: "signers",
    initialState,
    reducers: {
        setSigners(state, action) {
            state.signers = action.payload; 
        },
        addSigner(state, action) {
            state.signers.push(action.payload); 
        },
        removeSigner(state, action) {
            state.signers = state.signers.filter(signer => signer.id !== action.payload); 
        }
    },
});

export const { setSigners, addSigner, removeSigner } = signerSlice.actions;
export default signerSlice.reducer;
